import { useQueryClient } from '@tanstack/react-query';
import { Candidate } from 'model';
import { useCallback } from 'react';
import { useCandidateOrchestratorForCampaign } from './useCandidateOrchestratorForCampaign';
import { useCandidateOrchestratorForShare } from './useCandidateOrchestratorForShare';
import { useCandidateOrchestratorRatedCandidates } from './useCandidateOrchestratorRatedCandidates';

export const useCandidateOrchestrator = () => {
  const queryClient = useQueryClient();
  const coCampaign = useCandidateOrchestratorForCampaign();
  const coRatedCandidates = useCandidateOrchestratorRatedCandidates();
  const coShare = useCandidateOrchestratorForShare();

  const invalidateCredits = useCallback(() => queryClient.invalidateQueries(['userCredits']), [queryClient]);

  return useCallback(
    (candidate: Candidate) => ({
      campaign: coCampaign(candidate),
      ratedCandidates: coRatedCandidates(candidate),
      share: coShare(),
      invalidateCredits,
    }),
    [coCampaign, coShare, invalidateCredits],
  );
};
